/**
 * WCAG 2.4.1 "Bypass blocks" — visible only on keyboard focus. Admin
 * portal is internal English-only so no i18n dependency.
 */
export function SkipLink() {
  return (
    <a href="#main" className="skip-link">
      Skip to main content
    </a>
  );
}
